var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      attrs: {
        placement: "bottom-end",
        width: _vm.width,
        trigger: "hover",
        "popper-class": "popover-vip",
      },
      on: { show: _vm.getEquityInfo },
    },
    [
      _c("div", [
        _c(
          "div",
          {
            staticStyle: {
              padding: "14px 12px",
              "border-bottom": "1px solid #F2F2F2",
            },
          },
          [
            _c("div", [_c("b", [_vm._v("企业权益")])]),
            _c("div", { staticClass: "mt-10" }, [
              _vm._v(
                "到期时间：" +
                  _vm._s(
                    _vm.$store.state.user.closeDate &&
                      _vm.$store.state.user.closeDate.substring(0, 10)
                  )
              ),
            ]),
          ]
        ),
        _c("div", { staticStyle: { padding: "14px 12px" } }, [
          _c("p", [
            _vm._v("企业权益总条数"),
            _c("span", { staticClass: "fr" }, [
              _vm._v(
                _vm._s(_vm.$store.state.user.usedTotal) +
                  " / " +
                  _vm._s(_vm.$store.state.user.total)
              ),
            ]),
          ]),
        ]),
      ]),
      _c("img", {
        staticClass: "img-vip",
        attrs: { slot: "reference", src: require("@/assets/newicons/vip.svg") },
        slot: "reference",
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }